import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  OnChanges
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Capacitor } from '@capacitor/core';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { RichtextEditorComponent } from '@bling-fe/shared/ui-components/ui-richtext-editor';

@Component({
  selector: 'bl-comment-input',
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule,
    SvgIconComponent,
    RichtextEditorComponent
  ],
  templateUrl: './comment-input.component.html',
  styleUrl: './comment-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentInputComponent implements OnChanges {
  @Input() mode: 'new' | 'edit' = 'new';
  /**
   * Comment to be edited.
   */
  @Input() comment?: { id?: number; body?: string };
  @Input() submitting = false;

  @Output() create: EventEmitter<{ comment: string }> = new EventEmitter();
  @Output() update: EventEmitter<{ id: number; comment: string }> =
    new EventEmitter();
  @Output() cancelEditing: EventEmitter<void> = new EventEmitter();

  protected value = '';

  get disabledSubmit() {
    return !this.value || this.value.trim().length === 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['comment']) {
      this.value = this.comment?.body ?? '';
    }
  }

  onEnter() {
    if (Capacitor.getPlatform() !== 'web') {
      return;
    }

    if (!this.value || this.value.trim().length === 0) {
      return;
    }

    this.submit();
  }

  submit() {
    switch (this.mode) {
      case 'edit':
        if (this.comment?.id) {
          this.update.emit({ id: this.comment.id, comment: this.value });
        }
        this.mode = 'new';
        this.value = '';
        break;
      case 'new':
      default:
        this.create.emit({ comment: this.value });
        this.value = '';
        break;
    }
  }
}
